export default __webpack_public_path__ + "static/media/logo.6be7bbd8.svg";